import React, { useState, useEffect } from 'react';
import "../custom.css";

export default function ReadingingResult(props) {
	const [result, setResult] = useState(null);

	useEffect(() => {
		const { resultData } = props;
		setResult(resultData);
	}, []);

	const scoreClass = (score) => {
		let class_name = "color-danger";

		if (score > 30 && score <= 60) {
			class_name = "color-warning";
		} else if (score > 60) {
			class_name = "color-success";
		}

		return class_name;
	}

	const resultPercentage = () => {
		const { score, out_of } = result.score;

		return Math.round((score/out_of) * 100);
	}

	return (
		<>
			{result !== null &&
				<div className="visibility-visible">
					<div className='result-score-row result-score-row--inline d-flex flex-column flex-md-row align-items-center align-items-md-start gap-3 justify-content-center'>
						<div className='score-content' style={{ flexDirection: "column", alignItems: "start" }}>
							<div className='gap-3 d-flex align-items-center'>
								<div
									className='circle'
									style={{
										'--percent': resultPercentage(),
										'--color': (resultPercentage() > 0 ? '#94C23C' : '#E0E0E0'),
										'--size': '110px',
										'--thickness': '4px',
									}}
								>
									<div className="circle-inner">
										{result.score.score}/{result.score.out_of}
									</div>
								</div>
								<ul className="result-markers result-category reading" style={{ flexDirection: "column", alignItems: "flex-start", background: "transparent", padding: 0 }}>
										<li className="reading-result-good">
											<span></span>{props.subcategoryId === 10 ? "Correct Pair" : "Correct Answer"}
										</li>
										<li className="reading-result-bad">
											<span></span>{props.subcategoryId === 10 ? "Wrong Pair" : "Wrong Answer"}
										</li>
										{props.subcategoryId !== 10 &&
											<li className="reading-result-not-selected">
												<span></span>Not Selected But Correct Answer
											</li>
										}
								</ul>
							</div>
							<div className="result-view-remarks d-flex justify-content-start mt-2 w-100">
								{props?.moreDetails }
							</div>
						</div>
					</div>
				</div>
			}
		</>
	);
}
